<template>
  <div class="funcao-cadastro ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="6">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="funcoes.id_empresa"
            required
            :options="empresas"
            :multiple="true"
            @close="loadLiberarRecibos"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <!-- Customização do texto de seleção -->
            <template #selection="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} Empresa{{
                  values.length > 1 ? "s" : ""
                }}
                selecionada{{ values.length > 1 ? "s" : "" }}
              </span>
            </template>
          </multiselect>
        </b-col>

        <b-col cols="4">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscafuncao"
            class="ml-2 mr-5"
            v-model="search"
            required="required"
            placeholder="Tipo de recibo / competência folha"
          ></b-form-input>
        </b-col>

        <b-col cols="2">
          <br />
          <b-button
            variant="warning"
            block
            class="ml-2 mt-2 mr-2"
            v-b-modal.Liberarrecibo
            @click="reset(), loadTipoRecibo()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="funcoes"
      small
      hover
      striped
      sticky-header="880px"
      :items="itemsFuncaoFiltrar"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editLiberarRecibos(data.item)"
          title="Editar Função"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.Liberarrecibo
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--   LIBERAR RECIBOS MODAL -->
    <!--   LIBERAR RECIBOS MODAL -->
    <!--   LIBERAR RECIBOS MODAL -->

    <div>
      <b-modal
        id="Liberarrecibo"
        cancel-title="Fechar"
        centered
        ok-title="Gravar"
        @cancel="reset()"
        @close="reset()"
        hide-footer
        size="xl"
        title="Liberar consulta de recibos"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="7">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="liberarrecibo.empresa_id"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="5">
              <label for="input-filial">Liberar recibos</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="liberarrecibo.tipo_id"
                  required
                  :options="tiiporecibos"
                  class="mb-3"
                  text-field="tipo"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-2">
            <b-col cols="2">
              <label for="input-dtliberacao">Mês Liberado</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="liberarrecibo.periodo_liberado"
                required
                placeholder="Mês liberado"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="2" v-if="liberarrecibo.tipo_id === 1">
              <label for="input-dtliberacao">Data inicial</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="liberarrecibo.dt_inicial"
                required
                placeholder="Data inicial"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="2" v-if="liberarrecibo.tipo_id === 1">
              <label for="input-dtliberacao">Data final</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="liberarrecibo.dt_final"
                required
                placeholder="Data final"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="6">
              <b-form-checkbox
                id="lavador"
                class="mb-3 mt-5"
                v-model="liberarrecibo.bloqueio_liberacao"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
              >
                Bloquear liberação do tipo de recibo selecionado
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="2">
              <label for="input-live">DATA LIBERAÇÃO</label>
              <b-input-group-text>{{
                liberarrecibo.liberado_dt
                  ? moment(liberarrecibo.liberado_dt)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="4">
              <label for="input-live">LIBERADO POR</label>
              <b-input-group-text>{{
                liberarrecibo.liberado_id == 23280
                  ? "ML18- Lesser"
                  : liberarrecibo.liberado_registro
                  ? liberarrecibo.liberado_registro +
                    " - " +
                    liberarrecibo.liberado_funcao
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">DATA BLOQUEIO</label>
              <b-input-group-text>
                {{
                  liberarrecibo.bloqueou_dt
                    ? moment(liberarrecibo.bloqueou_dt)
                        .format("DD/MM/YYYY HH:mm")
                        .replace("Data inválida", "-")
                    : " - "
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="4">
              <label for="input-live">BLOQUEADO POR</label>
              <b-input-group-text>
                {{
                  liberarrecibo.bloqueou_id == 23280
                    ? "ML18 - Lesser"
                    : liberarrecibo.bloqueou_registro
                    ? liberarrecibo.bloqueou_registro +
                      " - " +
                      liberarrecibo.bloqueou_funcao
                    : "-"
                }}</b-input-group-text
              >
            </b-col>
          </b-row>

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postLiberarRecibos()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "LiberarreciboFuncao",

  computed: {
    ...mapState(["user"]),
    itemsFuncaoFiltrar() {
      let valorefuncao = [];
      valorefuncao = this.liberarrecibos.filter((item) => {
        return (
          item.tipo.indexOf(this.search) > -1 ||
          item.mes_liberado.indexOf(this.search) > -1
        );
      });
      return valorefuncao;
    },
  },

  data: function () {
    return {
      mode: "save",
      carregando: false,
      atualizando: false,

      empresas: [],
      liberarrecibos: [],
      tiiporecibos: [],
      liberarrecibo: {},
      funcoes: [],
      funcao: {}, // criando o objeto a ser editado no modal
      search: "",

      fields: [
        { key: "id", label: "Nº liberação", sortable: true },
        { key: "empresa_erp_id", label: "Empresa", sortable: true },
        { key: "tipo", label: "Tipo do Recibo", sortable: true },
        { key: "mes_liberado", label: "Mês liberado", sortable: true },
        {
          key: "liberado_dt",
          label: "Data liberação",
          sortable: true,
          formatter: (value, key, liberarrecibos) => {
            return moment(liberarrecibos.liberado_dt)
              .format("DD/MM/YYYY HH:MM")
              .replace("Data inválida", "-");
          },
        },
        { key: "liberado_registro", label: "RE liberação", sortable: true },
        { key: "liberado_funcao", label: "Função liberação", sortable: true },
        {
          key: "bloqueio_liberacao",
          label: "Bloqueado",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        {
          key: "bloqueou_dt",
          label: "Data bloqueio",
          sortable: true,
          formatter: (value, key, liberarrecibos) => {
            return moment(liberarrecibos.bloqueou_dt)
              .format("DD/MM/YYYY HH:MM")
              .replace("Data inválida", "-");
          },
        },
        { key: "bloqueou_registro", label: "RE bloqueio", sortable: true },
        { key: "bloqueou_funcao", label: "Função bloqueio", sortable: true },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
  },

  methods: {
    async loadEmpresa() {
      try {
        const params = {
          id_grupo_empresa: this.user.id_grupo_empresa,
          psg: this.user.psg, // Comentário mantido
        };

        const url = `${baseApiUrl}/ctr/empresa`;
        const response = await axios.get(url, { params });

        this.empresas = response.data.map((emp) => ({
          ...emp,
          value: emp.id_empresa,
          empresa: emp.nomeempresarial,
          id_filial_erp: emp.id_filial_erp,
        }));
      } catch (error) {
        showError(error); // Continua usando seu handler existente
      }
    },

    async loadLiberarRecibos() {
      try {
        const params = {
          empresa_id: this.user.id_empresa,
          psg: this.user.id_empresa === 2 ? "PSG_ML18" : this.user.psg, // Comentário mantido
        };

        const url = `${baseApiUrl}/folha/funcionario/liberarrecibo`;
        const response = await axios.get(url, { params });

        this.liberarrecibos = response.data;
      } catch (error) {
        showError(error); // Continua usando seu handler de erro personalizado
      }
    },

    async loadTipoRecibo() {
      try {
        const params = {
          empresa_id: this.user.id_empresa,
          psg: this.user.id_empresa === 2 ? "PSG_ML18" : this.user.psg, // Comentário mantido
        };

        const url = `${baseApiUrl}/folha/funcionario/liberarrecibotipo`;
        const response = await axios.get(url, { params });

        this.tiiporecibos = response.data.map((tp) => ({
          ...tp,
          value: tp.id,
          tipo: tp.tipo,
        }));
      } catch (error) {
        showError(error); // Continua usando seu handler de erro personalizado
      }
    },

    postLiberarRecibos() {
      let corpo = {
        empresa_id: `${this.liberarrecibo.empresa_id}`,
        empresa_erp_id: `${this.empresas.map((e) => e.id_empresa_erp)}`,
        id: `${this.liberarrecibo.id}`,
        tipo_id: `${this.liberarrecibo.tipo_id}`,
        periodo_liberado: `${this.liberarrecibo.periodo_liberado}`,
        bloqueio_liberacao: `${this.liberarrecibo.bloqueio_liberacao}`,
        dt_inicial: `${this.liberarrecibo.dt_inicial}`,
        dt_final: `${this.liberarrecibo.dt_final}`,
        funcionario_id: `${this.user.id_funcionario}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/folha/funcionario/liberarrecibo/cad`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(), this.reset(); //limpar os objetos valores
          this.loadLiberarRecibos();
        })
        .catch(showError);
    },

    reset() {
      this.liberarrecibo = {};
      //this.loadFuncoes()
    },

    editLiberarRecibos(liberarrecibo) {
      this.liberarrecibo = { ...liberarrecibo };
    },
  },

  created() {
    this.loadEmpresa();
    this.loadTipoRecibo();
  },

  mounted() {
    this.loadLiberarRecibos();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>